exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@font-face {\n  font-family: 'CocoGoose';\n  src: url(\"./assets/fonts/cocogoose.otf\") format(\"opentype\"); }\n\n@font-face {\n  font-family: 'Shree';\n  src: url(\"./assets/fonts/shree.otf\") format(\"opentype\"); }\n\n* {\n  box-sizing: border-box; }\n\na {\n  color: #AB40FF;\n  text-decoration: none; }\n  a:hover {\n    text-decoration: underline; }\n\nbody {\n  color: #111;\n  font-family: sans-serif;\n  margin: 0; }\n\nbutton, input, textarea {\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0); }\n\nhtml, body {\n  overflow-x: hidden !important;\n  max-width: 100vw !important; }\n", ""]);

// exports
